import Typography from '@mui/material/Typography';
import { useContext ,  useState , useEffect} from 'react';
import FormContext from '../../context/form-context';


const FormTitle = () => {
    const { appState } = useContext(FormContext);
    const [title , setTitle] = useState('');

    useEffect( () => {
        if(appState.formType.type !== '' && appState.formType.form !== ''){
            setTitle(appState.formType.form + ' - ' + appState.formType.type)
        }
    },[appState.formType.form , appState.formType.type])
    
    return (
        <>
            <Typography component="h3" variant="h4" align="center" id="back-to-top-anchor">
                {title}
            </Typography>
        </>

    );
}

export default FormTitle;
